export default "__VITE_ASSET__fc113bc1__"